import React, { useContext } from "react";

import { StoryQuestion } from "chq";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";
import DetailsTitle from "./DetailsTitle";
import PromptSelector from "./PromptSelector";
import DetailsLazyEditor from "./DetailsLazyEditor";
import DetailsSlackChannel from "./DetailsSlackChannel";

interface DetailsProps {
  fetching: boolean;
  storyQuestions: StoryQuestion[];
}

const Details: React.FC<DetailsProps> = ({ fetching, storyQuestions }) => {
  const { isControlledModeStories } = useContext(StoryModalContext);

  return (
    <>
      <DetailsTitle />
      {!isControlledModeStories && (
        <PromptSelector fetching={fetching} storyQuestions={storyQuestions} />
      )}
      <DetailsLazyEditor />
      <DetailsSlackChannel />
    </>
  );
};

export default Details;
